import { FlexGrid, Header, Image, Panel, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { capitalize, priceFormatter, trendToTrendWord } from '../../../lib/utils';
import { COUNTRY_CODES } from '../../constants';
import PriceUnits from '../../constants/priceUnits';
import CountryPropType from '../../prop-types/country';
import styles from './PriceTrends.module.css';

const cx = classnames.bind(styles);

export default function PriceTrends({ location, trend }) {
  const { t } = useTranslation(['price', 'trend']);
  const direction = trendToTrendWord(trend.trend).toLowerCase();
  const priceUnit = trend.country === COUNTRY_CODES.CANADA ? PriceUnits.CentsPerLiter : PriceUnits.DollarsPerGallon;

  return (
    <Fragment>
      <Header as="h2" className={cx('regionHeader')}>
        {t('gasPriceStats', { ns: 'price', location })}
      </Header>
      <Panel className={cx('panel')} color="white" bordered rounded>
        <FlexGrid container className={cx('pricingTrends')}>
          <FlexGrid.Column className={cx('priceColumn')} mobile={4}>
            <Text bold className={cx('priceHeader')} size="lg">
              {priceFormatter(trend.todayLow, priceUnit)}
            </Text>
            <br />
            <Text color="grey">
              {t('lowest', { ns: 'trend' })}
            </Text>
          </FlexGrid.Column>
          <FlexGrid.Column className={cx('priceColumn')} mobile={4}>
            <Text bold className={cx('priceHeader')} size="lg">
              {priceFormatter(trend.today, priceUnit)}
            </Text>
            <br />
            <Text color="grey">
              {t('average', { ns: 'trend' })}
            </Text>
          </FlexGrid.Column>
          <FlexGrid.Column className={cx('imageColumn')} mobile={4}>
            <Image
              className={cx('trendImage')}
              src={`https://www.gasbuddy.com/assets-v2/svg/arrow-${direction}-v1.svg`}
              alt=" "
              title={t(`trend${capitalize(direction)}`, { ns: 'trend' })} // alt not working in webkit?
            />
          </FlexGrid.Column>
        </FlexGrid>
      </Panel>
    </Fragment>
  );
}

PriceTrends.propTypes = {
  location: PropTypes.string.isRequired,
  trend: PropTypes.shape({
    country: CountryPropType,
    todayLow: PropTypes.number,
    today: PropTypes.number,
    trend: PropTypes.oneOf([-1, 0, 1]),
  }),
};

PriceTrends.defaultProps = {
  trend: {
    country: COUNTRY_CODES.USA,
    todayLow: 0,
    today: 0,
    trend: 0,
  },
};
